module.exports = __webpack_public_path__ + "static/media/home-hero.14bdb843.jpg";